import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify, { colors } from 'vuetify/lib';
import DatetimePicker from 'vuetify-datetime-picker';

Vue.use(Vuetify);
Vue.use(DatetimePicker);

// // для переключения тем
// // 1. Визначення системної теми
// const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
// // 2. Перевірка, чи є збережена тема
// const savedTheme = localStorage.getItem('theme');
// const isDark = savedTheme ? savedTheme === 'dark' : prefersDark;
// // для переключения тем

export default new Vuetify({
	icons: {
		iconfont: 'mdi',
	},
	theme: {
		// dark: isDark,
		// // dark: true,
		dark: false,
		themes: {
			light: {
				primary: colors.green.base,

				success: '#208538',

				green: '#208538',
				blue: '#1976D2',
				red: '#e91e63',
				error: '#e91e63',

			},
			dark: {
				primary: colors.green.lighten1,

				success: '#208538',

				green: '#208538',
				blue: '#1976D2',
				red: '#e91e63',
				error: '#e91e63',

			},
		},
	},
});
